<div class="col-md-12 p-3 d-flex justify-content-center">
    <div class="col-md-4 col-md-offset-4 rask-vit-panel py-1 p-x-3 d-flex justify-content-center">
        <h2>{{'MAINTENANCE_MODE' | translate}}</h2>
    </div>
</div>